/**
 * @deprecated
 * use singleChoiceWithText
 */
import React from 'react';
import SingleChoiceQuestionEditor, { Props as EditorProps } from './SingleChoiceQuestionEditor';
import SingleChoiceQuestionInput, { Props as InputProps } from './SingleChoiceQuestionInput';

type EditProps = EditorProps & {
  mode: 'edit';
}

type ViewProps = Pick<InputProps, 'question'> & {
  mode: 'view';
  deprecated?: boolean;
}

type SubmitProps = InputProps & {
  mode: 'submit';
  enrollmentId: number;
  sectionId: number;
  caseId?: number;
}

type Props = EditProps | ViewProps | SubmitProps;

const SingleChoiceQuestion: React.FC<Props> = (props: Props) => {
  const { mode } = props;

  if (mode === 'edit') {
    const {
      surveyId,
      sectionId,
      addQuestion,
      onCancelEdit,
      question,
      updateQuestion,
      disableHideAggregation,
    } = props as EditProps;
    return (
      <SingleChoiceQuestionEditor
        surveyId={surveyId}
        sectionId={sectionId}
        question={question}
        addQuestion={addQuestion}
        updateQuestion={updateQuestion}
        onCancelEdit={onCancelEdit}
        disableHideAggregation={disableHideAggregation}
      />
    );
  }

  if (mode === 'view') {
    const {
      question,
      deprecated,
    } = props as ViewProps;
    return (
      <SingleChoiceQuestionInput
        deprecated={deprecated}
        question={question}
      />
    );
  }

  if (mode === 'submit') {
    const {
      question,
      sectionId,
      caseId,
      enrollmentId,
      defaultSubmission,
      disabled,
      summarizedView,
      onSave,
    } = props as SubmitProps;
    return (
      <SingleChoiceQuestionInput
        question={question}
        sectionId={sectionId}
        caseId={caseId}
        enrollmentId={enrollmentId}
        disabled={disabled}
        onSave={onSave}
        defaultSubmission={defaultSubmission}
        summarizedView={summarizedView}
      />
    );
  }

  return null;
};

export default SingleChoiceQuestion;
